"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../enums/locale.js").IsoLanguagesRegions.EN;exports.DEFAULT_ISO_LANGUAGE_REGION=e;
//# sourceMappingURL=locale.js.map
